import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Avatar,
  CircularProgress,
  Alert,
} from '@mui/material';
import { Forum } from '@mui/icons-material';
import { authAPI, handleAPIError } from '../services/api';

const useStyles = makeStyles()((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(circle at 30% 20%, #13202b 0%, #0a0e12 100%)',
    padding: theme.spacing(2),
  },
  card: { width: '100%', maxWidth: 400 },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  logo: {
    backgroundColor: theme.palette.primary.main,
    color: '#06222b',
    width: 56,
    height: 56,
    marginBottom: theme.spacing(1.5),
  },
  field: { marginBottom: theme.spacing(2) },
  submit: { marginTop: theme.spacing(1) },
}));

const LoginPage = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { tenantId, scriptHash } = useParams();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authAPI.login(tenantId, scriptHash, { username, password });
      navigate(`/${tenantId}/${scriptHash}/settings`, { replace: true });
    } catch (err) {
      setError(handleAPIError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <div className={classes.header}>
            <Avatar className={classes.logo}>
              <Forum />
            </Avatar>
            <Typography variant="h5">Chat Admin</Typography>
            <Typography variant="body2" color="textSecondary">
              Sign in to manage your chat
            </Typography>
          </div>

          {error && (
            <Alert severity="error" style={{ marginBottom: 16 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              className={classes.field}
              label="Username or email"
              variant="outlined"
              fullWidth
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              disabled={loading}
            />
            <TextField
              className={classes.field}
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
            <Button
              className={classes.submit}
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              disabled={loading || !username || !password}
            >
              {loading ? <CircularProgress size={24} /> : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginPage;
